<ng-container *ngIf="visible">
    <div class="backdrop" (click)="onClosed()"></div>
    <div class="uppercase mobile__menu" >
        <ng-container *ngIf="canSeeBuyingWindows">
            <div class="menu__header font-weight-bold">{{orderWindowLabel}}
            </div>
            <div *ngIf="orderService.notEmptyOrderSummary" class="menu__item">
                <span class="price"><app-currency-price [price]="activeBWOrder.totalCost" [currency]="activeBWOrder.currency"></app-currency-price></span>
                <a routerLink="" class="link link-underline font-weight-bold" (click)="navigateToOrder(activeBWOrder)">View Order</a>
            </div>
            <div *ngIf="orderService.emptyOrderSummary" class="menu__item">
                Order Empty
                <a routerLink="" class="link link-underline font-weight-bold" (click)="navigateToAllBWPrograms()">Programs</a>
            </div>
            <div *ngIf="!orderService.activeOrderWindow" class="menu__item">
                No active {{orderWindowLabel}}
            </div>
        </ng-container>
        <div class="menu__header font-weight-bold">{{onDemandLabel}}</div>
        <div *ngIf="orderService.activeODOrder && orderService.activeODOrder.item_count > 0; else fixODOrder" class="menu__item">
            <span class="price"><app-currency-price [price]="activeODOrder.totalCost" [currency]="activeODOrder.currency"></app-currency-price></span>
            <a href="#" class="link link-underline font-weight-bold" (click)="navigateToOrder(activeODOrder)">Checkout</a>
        </div>
        <ng-template #fixODOrder>
            <div class="menu__item">
                Order Empty
                <a routerLink="" class="link link-underline font-weight-bold" (click)="navigateToProduct()">Shop</a>
            </div>
        </ng-template>
        <div class="menu__header mt-2" (click)="navigateToOrder()">View all open orders</div>
    </div>
</ng-container>

